<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import Pagination from "@/components/standard/OcupationalMedicine/dangerPagination";
import { sendNotification } from "@/utils/helpers/notification";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import ItemAPI from "@/services/items/itemsAPI";
import restriccionesColaboracionesAPI from "../../../services/standards/restriccionesColaboraciones/restriccionesColaboracionesAPI";
import RestriccionesPagination from "../../../components/standard/RestriccionesColaboraciones/RestriccionesPagination.vue";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Restricciones y recomendaciones laborales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
    Pagination,
    RestriccionesPagination,
  },
  data() {
    return {
      title: "3.1.6 Restricciones y recomendaciones laborales",
      items: [
        {
          text: "Estándares",
          href: "/",
        },
        {
          text: "Restricciones y recomendaciones laborales",
          active: true,
        },
      ],
      userSelected: null,
      usersList: [],
      lista: [],
      search: "",

      item: null,
      itemStatus: "No cumplido",

      itemData: null,

      file: null,
      listaII: null,

      ocupationalMedicine: {
        id: null,
        exam_date: null,
        file: null,
        exam_cycles_id: 1,
        employee_id: null,
        archivo: null,
        exam_status: 0,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading: true,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(28)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },


    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    fetch() {
      this.$refs.paginator.query();
    },

    getList() {
      restriccionesColaboracionesAPI
        .getOrderByID(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 28)
          .then((response) => {
            this.item = response || null;
            this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
          })
          .catch((error) => {
            this.item = null;
            this.itemStatus = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        this.itemStatus = null;
        console.log(error);
      }
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
            companies_id: this.companyID,
            item_id: 28,
            status: itemStatus,
          };
          newScoresAPI.calculateScores(itemChange)
          .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha cambiado el estado del ítem con éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              setTimeout(() => window.location.reload(), 2000)
          })
          .catch((error) => {
            Swal.fire({
              title: "¡ERROR!",
              text: "¡No se ha actualizado el estado del ítem!",
              icon: "error",
              type: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });

            setTimeout(() => window.location.reload(), 2000)
            console.log(error);
          });
    },
  },

  mounted() {
    this.getUsers();
    this.getList();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe garantizar el cumplimiento de las
                      restricciones y recomendaciones médico laborales
                      realizadas por parte de la Empresa Promotora de Salud
                      (EPS) o Administradora de Riesgos Laborales (ARL)
                      prescritas a los trabajadores para la realización de sus
                      funciones. Para dar cumplimiento a dichas recomendaciones,
                      se deberá realizar una reunión con el jefe del proceso, un
                      integrante del COPASST y el colaborador, donde se analicen
                      las recomendaciones o restricciones que tiene y si puede o
                      no continuar con las labores que viene desarrollando, de
                      no ser así se deberá adecuar el puesto de trabajo,
                      reubicar al trabajador o realizar la readaptación laboral
                      cuando se requiera.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>
              <div class="row">
                <div class="col-6 text-right m-b-0"></div>
                <div class="col-6 text-right m-b-0">
                  <button @click="
                    goPage(
                      `/forms/estandares/${companyID}/restricciones-colaboraciones-agregar`
                    )
                    " class="btn btn-primary mx-1">
                    <span class="btn-label">Agregar recomendación</span>
                  </button>
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                    <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                  </div>
                </div>

              </div>

              <hr v-if="getRole('Consultar') || !allowAccess()" />

              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead>
                          <tr>
                            <th>Fecha del examen</th>

                            <th class="text-center align-middle">
                              Colaborador
                            </th>
                            <th class="text-center align-middle">
                              Recomendaciones
                            </th>

                            <th class="text-center align-middle">Acciones</th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="dato in lista" :key="dato.id" :value="dato.id">
                            <td>
                              {{
                                dato.ocupational_medicals_exam_date != null
                                  ? dato.ocupational_medicals_exam_date
                                  : "Sin registro"
                              }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.full_name }}
                            </td>
                            <td class="text-center align-middle">
                              {{
                                dato.occupational_medical_dangers_note != null
                                  ? dato.occupational_medical_dangers_note
                                  : "Sin registro"
                              }}
                            </td>

                            <td class="text-center align-middle">
                              <div class="col-sm-12">
                                <div v-if="dato.occupational_medical_dangers_note !=
                                  null
                                ">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>

                                    <b-dropdown-item :disabled="!getRole('Consultar') || !allowAccess()
                                      " :to="{
                                        path: `/forms/estandares/${dato.companies_id}/restricciones-colaboraciones-seguimientos/${dato.occupational_medical_dangers_id}`,
                                      }">
                                      Seguimientos</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                                <div v-else></div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        <RestriccionesPagination ref="paginator" :search="search" @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
